// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28lik","left":"styles_left__3syJ7"};